import PerfectScrollbar from 'react-perfect-scrollbar';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { toggleSidebar } from '../store/themeConfigSlice';
import { useEffect, useState } from 'react';
import IconCaretsDown from './Icon/IconCaretsDown';
import IconMenuContacts from './Icon/Menu/IconMenuContacts';
import logoImg from '../assets/images/logo.svg';
import logoWhiteImg from '../assets/images/logo-white.png';
import ScheduleMeet from './Modal/ScheduleMeet';
import InstantMeet from './Modal/InstantMeet';
import IconMenuDashboard from './Icon/Menu/IconMenuDashboard';
import IconMenuCalendar from './Icon/Menu/IconMenuCalendar';
import IconMenuNotes from './Icon/Menu/IconMenuNotes';
import IconMenuForms from './Icon/Menu/IconMenuForms';
import IconMenuElements from './Icon/Menu/IconMenuElements';
import IconMenuUsers from './Icon/Menu/IconMenuUsers';
import IconMenuDatatables from './Icon/Menu/IconMenuDatatables';
import IconMenuComponents from './Icon/Menu/IconMenuComponents';
import IconGlobe from './Icon/IconGlobe';
import { useContext } from 'react';
import { AuthContext } from '../providers/AuthProvider';




const Sidebar = () => {
    const { user } = useContext(AuthContext);
    const themeConfig = useSelector((state) => state.themeConfig);
    const semidark = useSelector((state) => state.themeConfig.semidark);
    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [sopen, setSopen] = useState(false);
    const [iopen, setIopen] = useState(false);



    useEffect(() => {
        const selector = document.querySelector('.sidebar ul a[href="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul = selector.closest('ul.sub-menu');
            if (ul) {
                let ele = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    }, []);

    useEffect(() => {
        if (window.innerWidth < 1024 && themeConfig.sidebar) {
            dispatch(toggleSidebar());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return (
        <div className={semidark ? 'dark' : ''}>
            <nav
                className={`sidebar fixed min-h-screen h-full top-0 bottom-0 w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] z-50 transition-all duration-300 ${semidark ? 'text-white-dark' : ''}`}
            >
                <div className="bg-white dark:bg-black h-full">
                    <div className="flex justify-between items-center px-4 py-3">
                        <NavLink to="/" className="main-logo flex items-center shrink-0">
                            {themeConfig.theme === 'light' ? (
                                <img className="logo-img ml-[5px] flex-none" src={logoWhiteImg} alt="logo" />
                            ) : (
                                <img className="logo-img ml-[5px] flex-none" src={logoImg} alt="logo" />
                            )}
                        </NavLink>

                        <button
                            type="button"
                            className="collapse-icon w-8 h-8 rounded-full flex items-center hover:bg-gray-500/10 dark:hover:bg-dark-light/10 dark:text-white-light transition duration-300 rtl:rotate-180"
                            onClick={() => dispatch(toggleSidebar())}
                        >
                            <IconCaretsDown className="m-auto rotate-90" />
                        </button>
                    </div>
                    <PerfectScrollbar className="h-[calc(100vh-80px)] relative">
                        <ul className="relative font-semibold space-y-0.5 p-4 py-0">
                            <li className="nav-item">
                                <ul>
                                    <li className="nav-item">
                                        <NavLink to="/" className="group">
                                            <div className="flex items-center">
                                                <IconMenuDashboard className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('DashBoard')}</span>
                                            </div>
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/upcoming-mettings" className="group">
                                            <div className="flex items-center">
                                                <IconMenuCalendar className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Upcoming Meetings')}</span>
                                            </div>
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/recent-mettings" className="group">
                                            <div className="flex items-center">
                                                <IconMenuNotes className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Recent Meetings')}</span>
                                            </div>
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <button type='button' onClick={() => setSopen(true)} className="group">
                                            <div className="flex items-center">
                                                <IconMenuForms className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Schedule A Meeting')}</span>
                                            </div>
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button type='button' onClick={() => setIopen(true)} className="group">
                                            <div className="flex items-center">
                                                <IconMenuElements className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Instant Meeting')}</span>
                                            </div>
                                        </button>

                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/calendar" className="group">
                                            <div className="flex items-center">
                                                <IconMenuComponents className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Calendar')}</span>
                                            </div>
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/connect-stream" className="group">
                                            <div className="flex items-center">
                                                <IconMenuComponents className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">Streaming</span>
                                            </div>
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/contacts" className="group">
                                            <div className="flex items-center">
                                                <IconMenuDatatables className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Contacts')}</span>
                                            </div>
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/channels" className="group">
                                            <div className="flex items-center">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="group-hover:!text-primary shrink-0"><path opacity="0.5" d="M13 15.4C13 13.3258 13 12.2887 13.659 11.6444C14.318 11 15.3787 11 17.5 11C19.6213 11 20.682 11 21.341 11.6444C22 12.2887 22 13.3258 22 15.4V17.6C22 19.6742 22 20.7113 21.341 21.3556C20.682 22 19.6213 22 17.5 22C15.3787 22 14.318 22 13.659 21.3556C13 20.7113 13 19.6742 13 17.6V15.4Z" fill="currentColor"></path><path d="M2 8.6C2 10.6742 2 11.7113 2.65901 12.3556C3.31802 13 4.37868 13 6.5 13C8.62132 13 9.68198 13 10.341 12.3556C11 11.7113 11 10.6742 11 8.6V6.4C11 4.32582 11 3.28873 10.341 2.64437C9.68198 2 8.62132 2 6.5 2C4.37868 2 3.31802 2 2.65901 2.64437C2 3.28873 2 4.32582 2 6.4V8.6Z" fill="currentColor"></path><path d="M13 5.5C13 4.4128 13 3.8692 13.1713 3.44041C13.3996 2.86867 13.8376 2.41443 14.389 2.17761C14.8024 2 15.3266 2 16.375 2H18.625C19.6734 2 20.1976 2 20.611 2.17761C21.1624 2.41443 21.6004 2.86867 21.8287 3.44041C22 3.8692 22 4.4128 22 5.5C22 6.5872 22 7.1308 21.8287 7.55959C21.6004 8.13133 21.1624 8.58557 20.611 8.82239C20.1976 9 19.6734 9 18.625 9H16.375C15.3266 9 14.8024 9 14.389 8.82239C13.8376 8.58557 13.3996 8.13133 13.1713 7.55959C13 7.1308 13 6.5872 13 5.5Z" fill="currentColor"></path><path opacity="0.5" d="M2 18.5C2 19.5872 2 20.1308 2.17127 20.5596C2.39963 21.1313 2.83765 21.5856 3.38896 21.8224C3.80245 22 4.32663 22 5.375 22H7.625C8.67337 22 9.19755 22 9.61104 21.8224C10.1624 21.5856 10.6004 21.1313 10.8287 20.5596C11 20.1308 11 19.5872 11 18.5C11 17.4128 11 16.8692 10.8287 16.4404C10.6004 15.8687 10.1624 15.4144 9.61104 15.1776C9.19755 15 8.67337 15 7.625 15H5.375C4.32663 15 3.80245 15 3.38896 15.1776C2.83765 15.4144 2.39963 15.8687 2.17127 16.4404C2 16.8692 2 17.4128 2 18.5Z" fill="currentColor"></path></svg>
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Channels')}</span>
                                            </div>
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/profile" className="group">
                                            <div className="flex items-center">
                                                <IconMenuUsers className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Profile')}</span>
                                            </div>
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/contact-us" className="group">
                                            <div className="flex items-center">
                                                <IconMenuContacts className="group-hover:!text-primary shrink-0" />
                                                <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Contact Us')}</span>
                                            </div>
                                        </NavLink>
                                    </li>
                                    {user && user.role_id === 1 &&
                                        <li className="nav-item">
                                            <NavLink to="/admin" className="group">
                                                <div className="flex items-center">
                                                    <IconGlobe className="group-hover:!text-primary shrink-0" />
                                                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#fff] dark:group-hover:text-white-dark">{t('Admin')}</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    }
                                </ul>
                            </li>
                        </ul>
                    </PerfectScrollbar>
                </div>
            </nav>
            {/* Schedual meetings */}
            <ScheduleMeet sopen={sopen} setSopen={setSopen} />


            {/* instant meeting */}
            <InstantMeet iopen={iopen} setIopen={setIopen} />

        </div>
    );
};

export default Sidebar;
